// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import 'common/js/validate.js'
import {getRequest, postRequest, deleteRequest, putRequest, uploadFileRequest, downloadRequest} from 'common/js/http'
import {
  Autocomplete,
  Pagination,
  Menu,
  Submenu,
  MenuItem,
  Input,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  Icon,
  Loading,
  Message,
  Dialog,
  Tooltip
} from 'element-ui'
import 'common/stylus/index.styl'
/* import 'element-ui/lib/theme-chalk/index.css' */

Vue.config.productionTip = false
Vue.use(Autocomplete)
Vue.use(Pagination)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Input)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(Tooltip)
Vue.use(Loading.directive)
Vue.prototype.$message = Message
Vue.prototype.$loading = Loading.service
Vue.prototype.$http = axios
Vue.prototype.getRequest = getRequest
Vue.prototype.postRequest = postRequest
Vue.prototype.deleteRequest = deleteRequest
Vue.prototype.putRequest = putRequest
Vue.prototype.uploadFileRequest = uploadFileRequest
Vue.prototype.downloadRequest = downloadRequest

/* process.env.NODE_ENV === 'production' // 生产环境
process.env.NODE_ENV === 'development' // 开发环境 */

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js